import { useRef } from 'react'
import { Loader2, Search, X } from 'lucide-react'
import { IconButton } from '../primitives/IconButton'
import { Input } from './Controls'
import styles from './Forms.module.css'

export function SearchField({
  value = '',
  onChange,
  onSubmit,
  placeholder = 'Search…',
  label = 'Search',
  loading = false,
  clearLabel = 'Clear search',
  className = '',
  inputProps = {},
  form = true,
}) {
  const inputRef = useRef(null)
  const controls = (
    <>
      <Search className={styles.searchIcon} size={16} aria-hidden="true" />
      <Input
        {...inputProps}
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => onChange?.(event.target.value, event)}
        placeholder={placeholder}
        aria-label={label}
        aria-busy={loading || undefined}
        className={`${styles.searchInput} ${inputProps.className || ''}`.trim()}
        actions={[
          loading ? (
            <span key="loading" className={styles.searchStatus} role="status" aria-label="Loading results">
              <Loader2 size={16} aria-hidden="true" />
            </span>
          ) : value ? (
            <IconButton
              key="clear"
              variant="ghost"
              label={clearLabel}
              onClick={() => {
                onChange?.('')
                inputRef.current?.focus()
              }}
            >
              <X size={16} aria-hidden="true" />
            </IconButton>
          ) : null,
        ]}
      />
    </>
  )

  return (
    <search className={`${styles.search} ${className}`.trim()}>
      {form ? (
        <form
          className={styles.searchForm}
          onSubmit={(event) => {
            event.preventDefault()
            onSubmit?.(value)
          }}
        >
          {controls}
        </form>
      ) : (
        <div className={styles.searchForm}>{controls}</div>
      )}
    </search>
  )
}
